import { UserRole, UserRoleName } from '@plvs/graphql'
import { userRolesToUserType } from '@plvs/utils'
import * as intercom from './intercom/intercom'
import * as segment from './segment/segment'

export const { bootIntercom } = intercom

export const {
  group,
  identify,
  login,
  setRole,
  setRoleDescription,
  setSchool,
  setSchoolSubmission,
  seasonWizardActivated,
  seasonWizardDismissed,
  seasonWizardCompleted,
  playerActivationFlowTeamSelection,
  playerActivationFlowTeamActivation,
  playerActivationFlowCloseModalAfterAbandoned,
  connectAccountCTAAcknowledged,
  referralModalCTAConverted,
  votedOnArticle,
  readArticle,
  inAppClickedArticleCTA,
  watchedArticleVideo,
  openedArticleResource,
  clickedArticleCTA,
  productPlanSelected,
  nonSanctionedSchoolInterestedInStateOrConference,
  notificationService,
  billingContactAtSchool,
  transferVerifiedPlayer,
  scrimmageQueueShown,
  messageSentFromGlobal,
  globalChatTwilioCallAndDataBuilt,
  rewindOpenClicked,
  skillprintEmbedExpanded,
} = segment

// //////////////
// Hard Events //
// //////////////

type AnalyticsFnNoArgs = () => void

export const userRolesToOnboardingFeature = (
  userRoles: Pick<UserRole, 'roleName'>[]
): segment.Feature =>
  userRolesToUserType(userRoles) === UserRoleName.Coach
    ? segment.Feature.CoachOnboarding
    : segment.Feature.PlayerOnboarding

export const logout: AnalyticsFnNoArgs = () => {
  segment.reset()
}
